module.exports = __webpack_public_path__ + "static/btn.a75a29a6.png";